var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47 88C45.76 88 44.52 87.8359 43.52 87.4257C28.28 82.0103 4 62.8103 4 34.2564C4 19.7744 15.3201 8 29.2401 8C36.0001 8 42.32 10.7487 47 15.6308C51.68 10.7897 58.08 8 64.76 8C78.68 8 90 19.7744 90 34.2564C90 62.8103 65.7601 82.0103 50.4801 87.4257C49.4801 87.7949 48.24 87.959 47 87.959V88ZM29.2401 14.1538C18.6401 14.1538 10 23.1795 10 34.2564C10 62.6462 36.28 78.359 45.52 81.641C46.24 81.9282 47.7601 81.9282 48.4801 81.641C57.6801 78.359 84 62.6872 84 34.2564C84 23.1795 75.36 14.1538 64.76 14.1538C58.76 14.1538 53.0401 17.1487 49.4401 22.1949C48.3201 23.7538 45.7601 23.7949 44.6001 22.1949C40.9201 17.0667 35.3601 14.1538 29.2401 14.1538Z",
    fill: "#03182F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.64 77.7436C38.28 74.7898 14 60.3077 14 34.2975C14 25.477 20.8401 18.2975 29.2401 18.2975C34.0401 18.2975 38.4801 20.6359 41.3601 24.6565C42.6401 26.4616 44.76 27.5283 47 27.5283C49.24 27.5283 51.36 26.4616 52.64 24.6565C55.48 20.677 60.04 18.2975 64.76 18.2975C73.16 18.2975 80 25.477 80 34.2975C80 60.3077 55.7201 74.7898 47.2001 77.7847C47.2001 77.7847 46.76 77.7847 46.64 77.7436Z",
    fill: "#FF2B26"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.931efbe33999d86dab39f136e78d917a.svg";
export { ForwardRef as ReactComponent };